import { apiClient, handleApiError } from '@/lib/api/client';
import type { AuthResponse } from '@/types/auth.types';

export class AuthService {
  static async getProfile(): Promise<AuthResponse> {
    try {
      const response = await apiClient.get('/auth/profile');
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }
}
